import { createSelector } from 'reselect';
import type { State } from './types';

const getAllToasts = (state: State) => state.toasts || {};
export const selectToastsAsList = createSelector(getAllToasts, (toasts) => {
  return Object.values(toasts).slice(-4);
});
